(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("redux"), require("react-redux"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "redux", "react-redux"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("redux"), require("react-redux")) : factory(root["React"], root["redux"], root["react-redux"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EReduxPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_POPUP_TYPE; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getPopupConstant;
var EReduxPopup;
(function (EReduxPopup) {
    EReduxPopup["OPEN_POPUP"] = "OPEN";
    EReduxPopup["CLOSE_ACTIVE_POPUP"] = "CLOSE_ACTIVE_POPUP";
    EReduxPopup["CLOSE_ALL_POPUPS"] = "CLOSE_ALL";
    EReduxPopup["CLOSE_POPUP"] = "CLOSE";
})(EReduxPopup || (EReduxPopup = {}));
var DEFAULT_POPUP_TYPE = 'popup';
function getPopupConstant(type, constant) {
    return "@redux-popup/" + type + "/" + constant;
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





var noop = function () { return null; };
var ReduxPopup = (function (_super) {
    __extends(ReduxPopup, _super);
    function ReduxPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function () {
            var _a = _this.props.popupAction, popupAction = _a === void 0 ? noop : _a;
            popupAction(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* closeActivePopup */])());
        };
        return _this;
    }
    ReduxPopup.prototype.render = function () {
        var _a = this.props, Inner = _a.component, Dialog = _a.modal, name = _a.name, className = _a.className, type = _a.type, _b = _a.popupType, popupType = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DEFAULT_POPUP_TYPE */] : _b, modalProps = __rest(_a, ["component", "modal", "name", "className", "type", "popupType"]);
        var store = this.props[popupType] || {};
        var _c = store.sequence, sequence = _c === void 0 ? [] : _c;
        var active = sequence[sequence.length - 1];
        var dialogData = sequence.filter(function (dialog) { return dialog.name === name; })[0];
        var data = dialogData ? dialogData.data : {};
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Dialog, __assign({ active: active && (active.name === name) || false, onClose: this.onClose, className: className, type: type }, modalProps),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Inner, __assign({}, data))));
    };
    return ReduxPopup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var mapStateToProps = function (state, _a) {
    var _b;
    var _c = _a.popupType, popupType = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DEFAULT_POPUP_TYPE */] : _c;
    return _b = {},
        _b[popupType] = state[popupType],
        _b;
};
var mapDispatchToProps = function (dispatch, _a) {
    var _b = _a.popupType, popupType = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DEFAULT_POPUP_TYPE */] : _b;
    return {
        popupAction: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actionDecorator */])(popupType), dispatch),
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(ReduxPopup));


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = actionDecorator;
/* harmony export (immutable) */ __webpack_exports__["e"] = openPopup;
/* harmony export (immutable) */ __webpack_exports__["b"] = closeActivePopup;
/* harmony export (immutable) */ __webpack_exports__["c"] = closeAllPopups;
/* harmony export (immutable) */ __webpack_exports__["d"] = closePopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(0);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function actionDecorator(type) {
    if (type === void 0) { type = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_POPUP_TYPE */]; }
    return function (action) {
        return __assign({}, action, { type: Object(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* getPopupConstant */])(type, action.type) });
    };
}
function openPopup(name, data) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EReduxPopup */].OPEN_POPUP,
        payload: {
            name: name,
            data: data,
        }
    };
}
function closeActivePopup() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EReduxPopup */].CLOSE_ACTIVE_POPUP,
    };
}
function closeAllPopups() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EReduxPopup */].CLOSE_ALL_POPUPS,
    };
}
function closePopup(name) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EReduxPopup */].CLOSE_POPUP,
        payload: {
            name: name,
        }
    };
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(6);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReduxPopup__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createReduxPopup__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReduxPopup", function() { return __WEBPACK_IMPORTED_MODULE_0__ReduxPopup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createReduxPopup", function() { return __WEBPACK_IMPORTED_MODULE_1__createReduxPopup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "makePopupReducer", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_POPUP_TYPE", function() { return __WEBPACK_IMPORTED_MODULE_3__constants__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EReduxPopup", function() { return __WEBPACK_IMPORTED_MODULE_3__constants__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getPopupConstant", function() { return __WEBPACK_IMPORTED_MODULE_3__constants__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "actionDecorator", function() { return __WEBPACK_IMPORTED_MODULE_4__actions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "openPopup", function() { return __WEBPACK_IMPORTED_MODULE_4__actions__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "closePopup", function() { return __WEBPACK_IMPORTED_MODULE_4__actions__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "closeActivePopup", function() { return __WEBPACK_IMPORTED_MODULE_4__actions__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "closeAllPopups", function() { return __WEBPACK_IMPORTED_MODULE_4__actions__["c"]; });








/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createReduxPopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReduxPopup__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(0);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



function createReduxPopup(_a) {
    var name = _a.name, modal = _a.modal, _b = _a.modalProps, modalProps = _b === void 0 ? {} : _b, _c = _a.data, data = _c === void 0 ? {} : _c, _d = _a.popupType, popupType = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DEFAULT_POPUP_TYPE */] : _d, rest = __rest(_a, ["name", "modal", "modalProps", "data", "popupType"]);
    return function (WrappedComponent) {
        return function (props) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ReduxPopup__["a" /* default */], __assign({ name: name, component: WrappedComponent, data: data, modal: modal, popupType: popupType }, rest, props))); };
    };
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makePopupReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux__);


function makePopupReducer(type) {
    if (type === void 0) { type = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_POPUP_TYPE */]; }
    var sequence = function (state, action) {
        if (state === void 0) { state = []; }
        switch (action.type) {
            case Object(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* getPopupConstant */])(type, __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EReduxPopup */].OPEN_POPUP):
                return state.concat([action.payload]);
            case Object(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* getPopupConstant */])(type, __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EReduxPopup */].CLOSE_ACTIVE_POPUP):
                return state.slice(0, -1);
            case Object(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* getPopupConstant */])(type, __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EReduxPopup */].CLOSE_ALL_POPUPS):
                return [];
            case Object(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* getPopupConstant */])(type, __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EReduxPopup */].CLOSE_POPUP): {
                var name_1 = action.payload.name;
                return state.filter(function (popup) { return popup && popup.name !== name_1; });
            }
            default:
                return state;
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["combineReducers"])({
        sequence: sequence,
    });
}


/***/ })
/******/ ]);
});